"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setShareTitle = setShareTitle;
exports.setShareURL = setShareURL;
exports.showShareDialog = showShareDialog;

var _jquery = babelHelpers.interopRequireDefault(require("jquery"));

var _corePlugin = babelHelpers.interopRequireDefault(require("core-plugin"));

var shareURL;
var shortShareURL;
var shareTitle;

function setShareTitle(title) {
  shareTitle = title;
}

function setShareURL(URL, shortURL) {
  shareURL = URL;
  shortShareURL = shortURL;
}

function fbAsyncInit() {
  global.FB.init({
    appId: null,
    version: "v2.5",
    cookie: false,
    status: false,
    xfbml: false,
    frictionlessRequests: false,
    hideFlashCallback: null
  });
  didFacebookInit();
}

var isWaitingForFacebook = false,
    facebookLoaded = false;

function didFacebookInit() {
  facebookLoaded = true;
  var m = (0, _jquery.default)('#share-modal-wrap')[0];
  if (m) global.FB.XFBML.parse(m);
}

var isLoadingFacebook = false;

function loadFacebook() {
  if (!isLoadingFacebook) {
    global.fbAsyncInit = fbAsyncInit;
    var s = document.createElement('script');
    s.id = 'facebook-jssdk';
    s.src = '//connect.facebook.net/en_US/sdk.js';
    isLoadingFacebook = true;
    document.head.appendChild(s);
  }
}

function addModal() {
  (0, _jquery.default)(document.body).append("\n\t\t<div class='modal-wrapper' id='share-modal-wrap'>\n\t\t\t<div class='modal fade' id='share-modal' data-backdrop-parent='#share-modal-wrap' tabindex='-1'>\n\t\t\t\t<button type='button' class='close' data-dismiss='modal' aria-label='Close'>\n\t\t\t\t\t".concat(BLX.modalCloseButton(), "\n\t\t\t\t</button>\n\t\t\t\t<div class='modal-dialog'>\n\t\t\t\t\t<div class='modal-content'>\n\t\t\t\t\t\t<div class='modal-header'>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class='modal-body'>\n\t\t\t\t\t\t\t<div class='modal-body-inner'>\n\t\t\t\t\t\t\t\t<div class='share-dialog'>\n\t\t\t\t\t\t\t\t\t<div class='form-group'>\n\t\t\t\t\t\t\t\t\t\t<label for='share-modal-page-url'>Copy Page URL</label>\n\t\t\t\t\t\t\t\t\t\t<div class='input-group input-group-lg'>\n\t\t\t\t\t\t\t\t\t\t\t<input type='text' id='share-modal-page-url' class='form-control' readonly onfocus='this.select();'>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class='form-group social-container'>\n\t\t\t\t\t\t\t\t\t\t<label>Or Share On Social Networks</label>\n\t\t\t\t\t\t\t\t\t\t<div class=\"social-icons buttons\">\n\t\t\t\t\t\t\t\t\t\t\t<span class='btn-wrap'>\n\t\t\t\t\t\t\t\t\t\t\t\t<button class='btn btn-facebook' type='button'>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<img class=\"item\" src=\"/admin/platform/plugins/").concat(_corePlugin.default, "/resources/images/social/facebook.png\">\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class='social-button-container btn-facebook'></span>\n\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t<button class='btn btn-twitter' type='button'>\n\t\t\t\t\t\t\t\t\t\t\t\t<img class=\"item\" src=\"/admin/platform/plugins/").concat(_corePlugin.default, "/resources/images/social/twitter.png\">\n\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t"));
}

function showWindow(link, width, height) {
  var top = (screen.availHeight - height) / 2;
  var left = (screen.availWidth - width) / 2;
  left += screen.availLeft || 0;
  top += screen.availTop || 0;
  window.open(link, '_blank', "width=".concat(width, ",height=").concat(height, ",top=").concat(top, ",left=").concat(left, ",scrollbars=yes,resizable=yes,toolbar=no,location=yes"));
}

function showShareDialog() {
  (0, _jquery.default)('#share-modal-wrap').remove();
  addModal();
  (0, _jquery.default)('#share-modal-page-url').val(shortShareURL || shareURL || location.href);
  (0, _jquery.default)('#share-modal .btn-wrap > .btn-facebook').addClass('fb-share-button').attr({
    'data-href': shareURL,
    'data-layout': 'icon'
  });
  (0, _jquery.default)('#share-modal .btn-twitter').on('click', function (event) {
    return showWindow("https://twitter.com/intent/tweet?text=".concat(encodeURIComponent(shareTitle || ""), "&url=").concat(encodeURIComponent(shareURL)), 550, 420);
  });
  (0, _jquery.default)('#share-modal .btn-linkedin').on('click', function (event) {
    return showWindow("https://www.linkedin.com/shareArticle?url=".concat(encodeURIComponent(shareURL), "&mini=true&title=").concat(encodeURIComponent(shareTitle)), 570, 520);
  });
  if (!facebookLoaded) loadFacebook();else global.FB.XFBML.parse((0, _jquery.default)('#share-modal')[0]);
  (0, _jquery.default)('#share-modal').modal('show');
}